import React from "react"
import SharedTable from "../Common/table"
import formatDate from "../../helpers/format_date"

const Events = () => (
  <SharedTable
    collection={"events"}
    includeSearch={true}
    includeTitle={"Events"}
    isCompact={true}
    includeShowDeletedCheckbox={true}
    tableKeys={[
      { text: "Title", key: "title" },
      { text: "Organization" },
      { text: "Live Stream Date", key: "live_stream_date" },
      { text: "Created", key: "created_at" }
    ]}
    tableWidths={["auto", 200, 200, 200]}
    tableValues={[
      video => <span className='truncate'>{video.title}</span>,
      video => <span className='truncate'>{video.organization_name || 'N/A'}</span>,
      video => formatDate(video.live_stream_date),
      video => formatDate(video.created_at)
    ]}/>
)

export default Events
